import React, { Component, useEffect, useState } from 'react';
import TransactionsView from './TransactionsView';
import crmservices from '../../wsclient/';
import { getCurrency } from '../../utils/common';

function Transactions(props) {
            const [showLoading, onShowLoading] = useState(false);
            const [transactions, setTransactions] = useState(null);
            const currency = getCurrency();
            const [hasMore, setHasMore] = useState(true);
            const [showLoadMore, onShowLoadMore] = useState(false);
            const [paging, setPaging] = useState(null);
            const [transactionDetail, setTransactionDetail] = useState(null);
            const [showDetail, onShowDetail] = useState(false);
            const [purchaseId,setPurchaseId] = useState(null);
            const [showBreakdown, setShowBreakdown] = useState([]);
            const [lstPurchaseDetail, setLstPurchaseDetail] = useState([]);
            const [showLoadingProduct, setShowLoadingProduct] = useState(false);
    useEffect(()=>{
        onLoadRewardsTransactions(false)
    },[])
    
    const onLoadRewardsTransactions = async (isRefresh) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.getContactPurchases();
           //console.log('onLoadRewardsTransactions transactions result=',result)
            if (result.code == 'OK') {
                setTransactions(result.data.content);
                setPaging(result.data.paging);

                
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("load rewards transactions error:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async() =>{
       
        let page = paging.page+1
        setPaging(prevState =>({
            ...prevState,
            page: page
        }));
        onShowLoadMore(true);
        try {
            let result = await crmservices.contacts.getContactPurchases({page: page});
            //console.log('handleLoadMore transactions result=',result)
            if (result.code == 'OK') {
                setTransactions([...transactions,...result.data.content])
                
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("load rewards transactions error:", error);
        }
    }
    const onShowProduct = async (purchase) => {
        let _showBreakdown = showBreakdown;
        console.log("_showBreakdown:",_showBreakdown);
        let breakdown = _showBreakdown.filter(p => {
            return p == purchase.id
        })
        console.log("breakdown:",breakdown);
        if(breakdown && breakdown.length > 0){
            let breakdown = _showBreakdown.filter(p => {
                return p != purchase.id
            })
            setShowBreakdown(breakdown);
        }else{ 
            let _purchase = lstPurchaseDetail;
            console.log("_purchase:",_purchase);
            let _purchaseLoaded = _purchase.filter(p => {
                return p.id == purchase.id
            })
            console.log("_purchaseLoaded:",_purchaseLoaded);
            if(_purchaseLoaded && _purchaseLoaded.length > 0){
                _showBreakdown.push(purchase.id);
                console.log("AAAAAAA _showBreakdown:",_showBreakdown);
                setShowBreakdown(_showBreakdown);
            }else{ 
                setShowLoadingProduct(true);
                try {
                    var result = await crmservices.contacts.getPurchaseInfo(purchase.id);
                    if (result.code == 'OK') {
                        _purchase.push({id: purchase.id,detail:result.data});
                        setLstPurchaseDetail(_purchase);
                        _showBreakdown.push(purchase.id);
                        setShowBreakdown(_showBreakdown);
                    }else{
                        
                    }
                } catch (error) {
                    console.log("load rewards transactions error:", error);
                }
                setShowLoadingProduct(false);
            }
        }
    }
    const onClickDetail = async (item) =>{
        onShowLoading(true);
        console.log("purchaseId:",purchaseId);
        console.log("item:",item.id);
        if(purchaseId == item.id){
            setPurchaseId(null);
        }else{
            setPurchaseId(item.id);
            onShowDetail(true);
        }
        await onShowProduct(item);
        onShowLoading(false);
    }
    return (
        <div>
            <TransactionsView 
                open={props.open} 
                handleDrawerOtherToggle= {props.handleDrawerOtherToggle}
                transactions = {transactions}
                currency = {currency}
                handleLoadMore = {handleLoadMore}
                showLoadMore = {showLoadMore}
                hasMore= {hasMore}
                showLoading = {showLoading}
                onClickDetail = {onClickDetail}
                transactionDetail = {transactionDetail}
                showBreakdown={showBreakdown}
                showLoadingProduct={showLoadingProduct}
                lstPurchaseDetail={lstPurchaseDetail}
                showDetail={showDetail}/>
        </div>
    );
}

export default Transactions;